// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperAbstract-cls1_SDZ","cls2":"PaperAbstract-cls2_eeb PaperAbstract-cls1_SDZ"};